import React from "react";
//import Spinner from "../../components/utility/spinner";
import EmployeeShortage from "../../components/fragments/employee-shortage";
import AutoComplete from "../utility/auto-complete";
import CurrencyEntry from "../fragments/currency-entry";
import MessageBox from "../../components/utility/message-box";
import QuestionBox from "../utility/question-box";
import { currencyFormat, toExactFixted } from "../utility/util-methods";
import rq from "../utility/rq.js";
import tankStore from "../../store/tank-store";
import { tankConstant } from "../../constants/constants";
import update from "immutability-helper";
import Spinner from "../utility/spinner";
import { browserHistory } from "react-router";
import { DD_MM_YY } from "../utility/util-methods";
export default class CloseShift extends React.Component {
  constructor() {
    super();
    this.state = {
      isAtg: true,
      showSpinner: false,
      currentShift: null,
      tankList: tankStore.getAll(),
      mpds: {},
      products: {},
      credits: {},
      showShortageForm: true,
      showCurrencyForm: false,
      currencyFormReset: false,
      showCloseShiftBtn: false,
      comment: null,
    };

    this.messageBox = null;
    this.questionBox = null;
    this.handleTankStoreChange = this.handleTankStoreChange.bind(this);
  }

  setConsumption(nozzel) {
    nozzel.consumption = parseFloat(
      (nozzel.closeReading - nozzel.openReading - nozzel.testing).toFixed(3)
    );
    // console.log(nozzel);
    //console.log(nozzel.consumption);
  }

  calculateTotal(mpdId, productName) {
    this.state.mpds[mpdId].products[productName].totalQuantity = 0;
    this.state.mpds[mpdId].products[productName].totalPrice = 0;

    this.state.mpds[mpdId].nozzels.forEach((nozzel) => {
      if (nozzel.productName === productName) {
        this.state.mpds[mpdId].products[productName].totalQuantity +=
          parseFloat(
            (
              (nozzel.closeReading || nozzel.openReading) -
              nozzel.openReading -
              nozzel.testing
            ).toFixed(3)
          );
        //console.log("total quantity ", nozzel, this.state.mpds[mpdId].products[productName].totalQuantity);
        this.state.mpds[mpdId].products[productName].totalPrice += parseFloat(
          (
            ((nozzel.closeReading || nozzel.openReading) -
              nozzel.openReading -
              nozzel.testing) *
            this.state.products[nozzel.productId].sellingPrice
          ).toFixed(2)
        );
        //console.log("total price ", this.state.mpds[mpdId].products[productName].totalPrice);
      }
    });
  }
  onCloseReadingKeyUp(mpdId, nozzelIndex, nozelId, e) {
    let closeReading = 0;
    if (e) {
      closeReading = parseFloat(e.target.value);
    }
    if (closeReading >= 0) {
      this.state.mpds[mpdId].nozzels[nozzelIndex].closeReading = closeReading;
      this.setConsumption(this.state.mpds[mpdId].nozzels[nozzelIndex]);
      this.calculateTotal(
        mpdId,
        this.state.mpds[mpdId].nozzels[nozzelIndex].productName
      );
      //console.log(this.state.mpds);
    } else {
      this.state.mpds[mpdId].nozzels[nozzelIndex].closeReading = 0;
      //this.setState(this.state);
    }

    this.setState(this.state);
    // if (ok) {
    //     this.setState(this.state);
    // }
  }

  onTesting(mpdId, nozzelIndex, e) {
    //console.log(e.target.value, isNaN(e.target.value));
    if (parseFloat(e.target.value)) {
      //console.log(e.target.value);
      this.state.mpds[mpdId].nozzels[nozzelIndex].testing = parseFloat(
        e.target.value
      );
      this.setConsumption(this.state.mpds[mpdId].nozzels[nozzelIndex]);
      this.calculateTotal(
        mpdId,
        this.state.mpds[mpdId].nozzels[nozzelIndex].productName
      );
      //console.log(this.state.mpds);
      this.setState(this.state);
    } else {
      //console.log("--------");
      this.state.mpds[mpdId].nozzels[nozzelIndex].testing = 0;
      this.setConsumption(this.state.mpds[mpdId].nozzels[nozzelIndex]);
      this.calculateTotal(
        mpdId,
        this.state.mpds[mpdId].nozzels[nozzelIndex].productName
      );
      this.setState(this.state);
    }
  }

  reset(mpdId) {
    this.state.mpds[mpdId].lastCashCollection = {};
    this.state.mpds[mpdId].resetEmployeeAuto = true;
    this.state.mpds[mpdId].employeeShortageList = [];
    this.state.mpds[mpdId].shortageAmount = 0;
    //console.log("reset...", this.state.mpds[mpdId]);
  }

  calculateTotalSwpipe(mpdId) {
    var totalAmount = 0;

    this.state.mpds[mpdId].swipeMachines.forEach((swipeMachine) => {
      totalAmount += swipeMachine.amount ? swipeMachine.amount : 0;
    });
    return totalAmount;
  }

  updateSwipeAmount(index, mpdId, e) {
    //console.log(this.state.mpds[mpdId]);
    this.reset(mpdId);
    var swipeAmount = parseFloat(e.target.value)
      ? parseFloat(e.target.value)
      : 0;
    this.state.mpds[mpdId].swipeMachines[index].amount = swipeAmount;
    this.setState(this.state);
  }
  handleTankStoreChange() {
    this.setState({ tankList: tankStore.getAll() });
  }
  componentWillMount() {
    this.questionBox = (
      <QuestionBox
        questionMsg="Have you entered all expenditure and stock in data ?"
        yesCallBack={() => {
          this.questionBox = null;
          this.setState({});
        }}
        noCallBack={() => {
          browserHistory.push("/");
        }}
      ></QuestionBox>
    );
    tankStore.on(tankConstant.TANK_STORE_CHANGE, this.handleTankStoreChange);
    this.makeAjax(
      "/api/v1/shiftdetail",
      (data) => {
        this.state.currentShift = data[0];
        // console.log("fetched current shift");
        this.setState(this.state);
      },
      () => {
        alert("getting shift detail failed");
      }
    );

    this.makeAjax(
      "/api/v1/closeshiftdata",
      (data) => {
        data[0].forEach((nozzel) => {
          nozzel.testing = 0;
          nozzel.consumption = 0;
          if (!this.state.mpds[nozzel.mpdId]) {
            this.state.mpds[nozzel.mpdId] = {
              mpdName: nozzel.mpdName,
              nozzels: [],
              products: {},
              lastCashCollection: {},
            };
            this.state.mpds[nozzel.mpdId].products[nozzel.productName] = {
              totalQuantity: 0,
              totalPrice: 0,
            };

            this.state.mpds[nozzel.mpdId].nozzels.push(nozzel);
          } else {
            this.state.mpds[nozzel.mpdId].products[nozzel.productName] = {
              totalQuantity: 0,
              totalPrice: 0,
            };

            this.state.mpds[nozzel.mpdId].nozzels.push(nozzel);
          }
        });

        data[1].forEach((product) => {
          this.state.products[product.productId] = product;
        });

        data[2].forEach((creditData) => {
          if (!this.state.credits[creditData.mpdId]) {
            this.state.credits[creditData.mpdId] = {};
            this.state.credits[creditData.mpdId][creditData.productName] =
              creditData;
          } else {
            this.state.credits[creditData.mpdId][creditData.productName] =
              creditData;
          }
        });

        data[3].forEach((cashCollection) => {
          this.state.mpds[cashCollection.mpdId].cashCollection = cashCollection;
        });

        // this.state.swipeData = data[4];
        // ading swipemachines to each mpds
        Object.keys(this.state.mpds).forEach((mpdId) => {
          this.state.mpds[mpdId].swipeMachines = JSON.parse(
            JSON.stringify(data[4])
          );
          this.state.mpds[mpdId].employeeShortageList = [];
        });

        //window.pp = this.state;
        //console.log(this.state);
        // console.log("fetched all data");
        this.state.showCloseShiftBtn = true;
        //this.setState(this.state);
        this.getTempData();
      },
      () => {
        this.messageBox = MessageBox.showMessage(
          "No shift is running !!!",
          false,
          this
        );
        this.forceUpdate();
      }
    );
  }
  componentWillUnmount() {
    tankStore.removeListener(
      tankConstant.TANK_STORE_CHANGE,
      this.handleTankStoreChange
    );
  }
  getProductBackground(productName) {
    var backgroundColor = "";
    switch (productName) {
      case "HS":
        backgroundColor = "#046c9e";
        break;
      case "MS":
        backgroundColor = "#5f7929";
        break;
      default:
        break;
    }
    return backgroundColor;
  }

  onShortageSave(mpdId, epmloyeeShortage) {
    // console.log(epmloyeeShortage);
    this.state.mpds[mpdId].employeeShortageList = epmloyeeShortage;
    this.state.mpds[mpdId].showShortageForm = false;
    this.setState(this.state);
  }

  onShortageCancle(mpdId) {
    // console.log("........",mpdId);
    this.state.mpds[mpdId].showShortageForm = false;
    this.setState(this.state);
  }
  onEmployeeSelect(mpdId, employee) {
    if (employee) {
      this.state.mpds[mpdId].lastCashCollection.employeeId =
        employee.employeeId;
      this.state.mpds[mpdId].lastCashCollection.employeeName =
        employee.employeeName;
    }
  }
  onCurrencySave(mpdId, currencyData, cashInTotal, cashOutTotal) {
    var netCashIn = cashInTotal - cashOutTotal;
    if (netCashIn >= 0) {
      this.state.mpds[mpdId].lastCashCollection.amount = netCashIn;
      // This is done for deep cloning currencyData
      this.state.mpds[mpdId].lastCashCollection.currencyData = JSON.parse(
        JSON.stringify(currencyData)
      );

      this.state.mpds[mpdId].lastCashCollection.cashInTotal = cashInTotal;
      this.state.mpds[mpdId].lastCashCollection.cashOutTotal = cashOutTotal;

      var amountTobeCollected = this.getTotalCashTobeCollected.bind(
        this,
        mpdId
      )();
      if (amountTobeCollected - netCashIn > 10) {
        this.state.mpds[mpdId].shortageAmount = parseInt(
          amountTobeCollected - netCashIn,
          10
        );
        this.state.mpds[mpdId].showShortageForm = true;
      }
      this.state.mpds[mpdId].showCurrencyForm = false;
    } else {
      this.messageBox = MessageBox.showMessage(
        "Total amount should be positive !",
        false,
        this
      );
    }
    this.setState(this.state);
  }

  onCurrencyCancel(mpdId) {
    this.state.mpds[mpdId].showCurrencyForm = false;
    this.setState(this.state);
  }

  onAmountClicked(mpdId) {
    this.state.mpds[mpdId].showCurrencyForm = true;
    this.setState(this.state);
  }

  onShortageClick(mpdId) {
    //if(this.state.mpds[mpdId])
    this.state.mpds[mpdId].showShortageForm = true;
    this.setState(this.state);
  }

  componentDidUpdate() {
    Object.keys(this.state.mpds).forEach((mpdId) => {
      this.state.mpds[mpdId].resetEmployeeAuto = false;
    });
    //console.log(">>>>", this.state);
  }

  validateCreditData(mpd, mpdId) {
    //console.log(mpd);
    //console.log("state--", this.state);
    var nozzels = Object.keys(mpd.nozzels);
    var productCosumption = {};

    for (var i = 0; i < nozzels.length; i++) {
      var x = productCosumption.hasOwnProperty(mpd.nozzels[i]["productName"]);
      var productName = "";
      if (!x) {
        productName = mpd.nozzels[i]["productName"];
        productCosumption[productName] = mpd.nozzels[i].consumption;
      } else {
        productName = mpd.nozzels[i]["productName"];
        productCosumption[productName] += mpd.nozzels[i].consumption;
      }
    }
    var products = Object.keys(productCosumption);

    for (var k = 0; k < products.length; k++) {
      //console.log("crdet quatity", this.state.credits[mpdId][products[k]].quantity);
      // console.log("consumption ", productCosumption[products[k]]);
      var success = false;
      if (
        this.state.credits[mpdId][products[k]].quantity <=
        productCosumption[products[k]]
      ) {
        //console.log("success credit", this.state.credits[mpdId][products[k]].quantity, "consumption", productCosumption[products[k]]);
        success = true;
      } else {
        //console.log("failed credit", this.state.credits[mpdId][products[k]].quantity, "consumption", productCosumption[products[k]]);

        // close shift validation

        this.messageBox = MessageBox.showMessage(
          `Cosumption of ${products[k]} in  ${mpd.mpdName} should not be less than credit quantity`,
          false,
          this
        );
        success = false;
        //success = true;
        break;
        //success = true;
      }
    }

    return success;
  }

  validateTotalSwipe(mpd, mpdId) {
    var TotalSale = parseFloat(this.getTotalSaleinRupees(mpdId));
    var TotalCreditSale = parseFloat(this.getTotalCreditSaleinRupees(mpdId));
    var TotalCashCollection = parseFloat(mpd.cashCollection.cashCollection);
    var TotalSwipe = this.calculateTotalSwpipe(mpdId);
    var success = false;
    if (
      TotalSwipe <=
      (TotalSale - TotalCreditSale - TotalCashCollection).toFixed(2)
    ) {
      success = true;
    } else {
      // close shift validation
      this.messageBox = MessageBox.showMessage(
        `Total swipe of ${mpd.mpdName} must not be greater than (Total sale -Total credit)- total cash`,
        false,
        this
      );
      success = false;
      // success = true;
    }
    return success;
  }
  validateCashCollected(mpd, mpdId) {
    var TotalSale = parseFloat(this.getTotalSaleinRupees(mpdId));
    var TotalCreditSale = parseFloat(this.getTotalCreditSaleinRupees(mpdId));
    var TotalCashCollection = mpd.cashCollection.cashCollection;
    var success = false;
    if (TotalCashCollection <= (TotalSale - TotalCreditSale).toFixed(2)) {
      success = true;
    } else {
      // close shift validation
      this.messageBox = MessageBox.showMessage(
        `Total cash collection of ${mpd.mpdName} must not be greater than (Total sale - Total credit)`,
        false,
        this
      );
      success = false;
      //success = true;
    }

    return success;
  }
  validateMpdData(mpd) {
    //console.log(mpd);
    /**
     * @param {object} mpd
     * @return {boolean} success or failure
     */

    var nozzels = Object.keys(mpd.nozzels);
    var success = false;
    for (var i = 0; i < nozzels.length; i++) {
      if (mpd.nozzels[i].closeReading >= 0) {
        if (mpd.nozzels[i].closeReading >= mpd.nozzels[i].openReading) {
          if (mpd.nozzels[i].testing >= 0) {
            if (
              mpd.nozzels[i].testing <=
              mpd.nozzels[i].closeReading - mpd.nozzels[i].openReading
            ) {
              success = true;
            } else {
              this.messageBox = MessageBox.showMessage(
                `Tesing of ${mpd.nozzels[i].mpdName} nozzel: ${mpd.nozzels[i].nozelName}-${mpd.nozzels[i].productName} must be less than total consuption`,
                false,
                this
              );
              success = false;
              break;
            }
          } else {
            this.messageBox = MessageBox.showMessage(
              `Tesing of ${mpd.nozzels[i].mpdName} nozzel: ${mpd.nozzels[i].nozelName}-${mpd.nozzels[i].productName} must be greaterthan or equal to 0`,
              false,
              this
            );
            success = false;
            break;
          }
        } else {
          this.messageBox = MessageBox.showMessage(
            `Close reading of ${mpd.nozzels[i].mpdName} nozzel: ${mpd.nozzels[i].nozelName}-${mpd.nozzels[i].productName} must be greater than open reading`,
            false,
            this
          );
          success = false;
          break;
        }
      } else {
        this.messageBox = MessageBox.showMessage(
          `Please enter close reading of ${mpd.nozzels[i].mpdName} nozzel: ${mpd.nozzels[i].nozelName}-${mpd.nozzels[i].productName}`,
          false,
          this
        );
        success = false;
        break;
      }
    }

    return success;
  }

  validateTotalShortage(mpd, mpdId) {
    // console.log(mpd);
    //console.log(this.state);

    var totalSale = parseFloat(this.getTotalSaleinRupees(mpdId));
    var totalCreditSale = parseFloat(this.getTotalCreditSaleinRupees(mpdId));
    var totalSwpipe = parseFloat(this.calculateTotalSwpipe(mpdId));
    var cashCollection = mpd.cashCollection.cashCollection;
    var totalEmployeeShortage = parseFloat(
      this.getTotalEmployeeShortage(mpdId)
    );
    var totalAmountToCollect = parseFloat(
      (totalSale - totalCreditSale - (cashCollection + totalSwpipe)).toFixed(2)
    );
    var success = false;

    if (totalAmountToCollect > 0) {
      if (mpd.lastCashCollection.amount > 0) {
        if (mpd.lastCashCollection.employeeId > 0) {
          if (totalAmountToCollect - mpd.lastCashCollection.amount > 10) {
            if (
              parseInt(
                totalAmountToCollect - mpd.lastCashCollection.amount,
                10
              ) === totalEmployeeShortage
            ) {
              success = true;
            } else {
              success = false;
              this.messageBox = MessageBox.showMessage(
                `Total Shortage amount must be ${parseInt(
                  totalAmountToCollect - mpd.lastCashCollection.amount,
                  10
                )} in ${mpd.mpdName}`,
                false,
                this
              );
            }
          } else {
            success = true;
          }
        } else {
          success = false;
          this.messageBox = MessageBox.showMessage(
            "Please select a employee from whom last collection made",
            false,
            this
          );
        }
      } else {
        success = false;
        this.messageBox = MessageBox.showMessage(
          "Please enter last cash collection amount",
          false,
          this
        );
      }
    } else {
      //cash to be collected is less than 0 What to Do ??
      //console.log("amount to collect is negative");
      success = true;
    }

    return success;
    // console.log(totalAmountToCollect);
  }

  closeShift() {
    this.askQuestion(
      `Do you watnt close shift  ${this.state.currentShift.shiftName} ?`,
      () => {
        var ok = Object.keys(this.state.mpds).every((mpdId) => {
          if (
            this.validateMpdData(this.state.mpds[mpdId]) &&
            this.validateCreditData(this.state.mpds[mpdId], mpdId) &&
            this.validateCashCollected(this.state.mpds[mpdId], mpdId) &&
            this.validateTotalSwipe(this.state.mpds[mpdId], mpdId) &&
            this.validateTotalShortage(this.state.mpds[mpdId], mpdId)
          )
            return true;
          else return false;
        });

        if (this.validateTankDip()) {
          if (ok) {
            this.setState({ showSpinner: true });
            // time to send data to server
            // console.log("---", this.state);
            rq.postJson("/api/v1/closeshift", this.state)
              .then((closeShiftData) => {
                this.messageBox = MessageBox.showMessage(
                  "shift close successfully",
                  true,
                  this
                );
                //this.clearData();
                window.localStorage.removeItem("storeData");
                this.setState({ showSpinner: false }, () => {
                  this.askQuestion(
                    "Do you want to start a new shift",
                    () => {
                      browserHistory.push("/page/start-shift");
                    },
                    () => {}
                  );
                });

                // setTimeout(() => {
                //     browserHistory.push("/page/start-shift");
                // }, 000);
              })
              .catch(() => {
                this.messageBox = MessageBox.showMessage(
                  "shift close faild",
                  false,
                  this
                );
                this.setState({ showSpinner: false });
              });
          } else {
            // alert("An error in frontend");
          }
        } else {
          this.messageBox = MessageBox.showMessage(
            "plase enter All dip value",
            false,
            this
          );
          this.forceUpdate();
        }
        this.questionBox = null;
        this.forceUpdate();
      },
      () => {
        //this.messageBox = MessageBox.showMessage("How are you ", true, this);
        this.questionBox = null;
        this.forceUpdate();
      }
    );
  }

  askQuestion(msg, yesCallBack, noCallBack) {
    this.questionBox = (
      <QuestionBox
        questionMsg={msg}
        yesCallBack={yesCallBack}
        noCallBack={noCallBack}
      ></QuestionBox>
    );
    this.setState(this.state);
  }
  storeData() {
    window.localStorage.setItem("storeData", JSON.stringify(this.state));
    this.messageBox = MessageBox.showMessage(
      "Data save temporarily",
      true,
      this
    );
    this.forceUpdate();
  }
  clearData() {
    window.localStorage.removeItem("storeData");
    this.messageBox = MessageBox.showMessage(
      "Temporary data cleared",
      true,
      this
    );
    this.forceUpdate();
  }
  getTempData() {
    let tempData = JSON.parse(window.localStorage.getItem("storeData"));

    if (tempData) {
      // update nozzel data
      // [1 2 3]
      var mpds = Object.keys(tempData.mpds);

      this.state.comment = tempData.comment;

      //console.log("oo------------", this.state.mpds);
      mpds.forEach((mpd, index) => {
        // [{},{}]
        let products = Object.keys(tempData.mpds[mpd].products);
        // console.log("-----------", products);
        tempData.mpds[mpd].nozzels.forEach((nozzel, index) => {
          this.state.mpds[mpd].nozzels[index] = Object.assign(
            {},
            this.state.mpds[mpd].nozzels[index],
            nozzel
          );
        });

        products.forEach((product) => {
          this.state.mpds[mpd].products[product] = Object.assign(
            {},
            this.state.mpds[mpd].products[product],
            tempData.mpds[mpd].products[product]
          );
        });

        tempData.mpds[mpd].swipeMachines.forEach((swipeMachine, index) => {
          this.state.mpds[mpd].swipeMachines[index] = Object.assign(
            {},
            this.state.mpds[mpd].swipeMachines[index],
            tempData.mpds[mpd].swipeMachines[index]
          );
        });

        this.state.mpds[mpd].lastCashCollection = Object.assign(
          {},
          this.state.mpds[mpd].lastCashCollection,
          tempData.mpds[mpd].lastCashCollection
        );
        this.state.mpds[mpd].employeeShortageList = Object.assign(
          [],
          this.state.mpds[mpd].employeeShortageList,
          tempData.mpds[mpd].employeeShortageList
        );

        this.state.tankList = Object.assign(
          [],
          this.state.tankList,
          tempData.tankList
        );
      });
      //console.log("xxxx", this.state);
      //console.log("condole---", newMpds);
      // this.setState({ mpds: newMpds });

      // console.log("going to call render again");
      // mpds.forEach((mpd, index) => {
      //     setTimeout(() => {
      //         this.onCloseReadingKeyUp(mpd, );
      //     }, 5000);

      // })

      // setTimeout(() => {
      //     this.onCloseReadingKeyUp(1, 1, 2);
      // }, 5000);
    }
    //window.xx = this.state;
    //this.setState(this.state);
  }
  render() {
    //console.log("render called", this.state);
    return (
      <div className="closeShiftPage">
        <div
          onClick={this.clearData.bind(this)}
          className="boxShadow availableCash"
          style={{
            lineHeight: "50px",
            position: "fixed",
            bottom: 80,
            right: 15,
            background: "#ca2c47",
          }}
        >
          <i className="fa fa-trash-o" aria-hidden="true"></i>
        </div>
        <div
          onClick={this.storeData.bind(this)}
          className="boxShadow availableCash"
          style={{
            lineHeight: "50px",
            position: "fixed",
            bottom: 155,
            right: 15,
            background: "#309030",
          }}
        >
          <i className="fa fa-floppy-o"></i>
        </div>

        {this.state.showSpinner ? <Spinner></Spinner> : null}
        {this.state.currentShift ? (
          <h2 style={{ textAlign: "center", fontSize: "22px" }}>
            {" "}
            Shift Date: {DD_MM_YY(this.state.currentShift.shiftDate)} Shift :{" "}
            {this.state.currentShift.shiftName}
          </h2>
        ) : (
          ""
        )}
        {Object.keys(this.state.mpds).map((mpdId) => {
          return (
            <div key={mpdId}>
              <h2 className="mpd">{this.state.mpds[mpdId].mpdName}</h2>
              <div style={{ paddingLeft: "10px" }}>
                <table className="shiftClose">
                  <thead>
                    <tr>
                      <th></th>
                      {this.state.mpds[mpdId].nozzels.map((nozzel) => {
                        return (
                          <th
                            style={{
                              backgroundColor: this.getProductBackground(
                                nozzel.productName
                              ),
                            }}
                            key={nozzel.nozelId}
                          >
                            {nozzel.nozelName} - {nozzel.productName}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Open reading</td>
                      {this.state.mpds[mpdId].nozzels.map((nozzel) => {
                        return (
                          <td className="center" key={nozzel.nozelId}>
                            {nozzel.openReading}
                          </td>
                        );
                      })}
                    </tr>

                    <tr>
                      <td>Close reading</td>
                      {this.state.mpds[mpdId].nozzels.map(
                        (nozzel, nozzelIndex) => {
                          return (
                            <td className="center" key={nozzel.nozelId}>
                              <input
                                defaultValue={nozzel.closeReading}
                                onKeyUp={this.onCloseReadingKeyUp.bind(
                                  this,
                                  mpdId,
                                  nozzelIndex,
                                  nozzel.nozelId
                                )}
                                type="text"
                                ref={nozzel.nozelId}
                                className="closeReading"
                              />
                            </td>
                          );
                        }
                      )}
                    </tr>

                    <tr>
                      <td>Testing</td>
                      {this.state.mpds[mpdId].nozzels.map(
                        (nozzel, nozzelIndex) => {
                          return (
                            <td className="center" key={nozzel.nozelId}>
                              <input
                                onKeyUp={this.onTesting.bind(
                                  this,
                                  mpdId,
                                  nozzelIndex
                                )}
                                type="text"
                                className="closeReading"
                                defaultValue={nozzel.testing}
                              />
                            </td>
                          );
                        }
                      )}
                    </tr>

                    <tr>
                      <td>Consumption</td>
                      {this.state.mpds[mpdId].nozzels.map((nozzel) => {
                        return (
                          <td className="center" key={nozzel.nozelId}>
                            {nozzel.closeReading >= 0 ? nozzel.consumption : ""}
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>

                <table className="shiftClose">
                  <thead>
                    <tr>
                      <th></th>
                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <th
                              key={productName}
                              style={{
                                backgroundColor:
                                  this.getProductBackground(productName),
                              }}
                            >
                              {productName}
                            </th>
                          );
                        }
                      )}
                      <th style={{ background: "red" }}>Total Sale</th>

                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <th
                              key={productName}
                              style={{
                                backgroundColor:
                                  this.getProductBackground(productName),
                              }}
                            >
                              {productName} credit
                            </th>
                          );
                        }
                      )}
                      <th style={{ background: "red" }}>Total Credit Sale</th>

                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <th
                              key={productName}
                              style={{
                                backgroundColor:
                                  this.getProductBackground(productName),
                              }}
                            >
                              {productName} cash
                            </th>
                          );
                        }
                      )}

                      <th style={{ background: "red" }}>Total Cash Sale</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>In-Qty.</td>
                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <td key={productName} className="center">
                              {toExactFixted(
                                this.state.mpds[mpdId].products[productName]
                                  .totalQuantity,
                                3
                              )}
                            </td>
                          );
                        }
                      )}

                      {/*total sale*/}

                      <td className="center">
                        {this.getTotalSaleQuanity.bind(this, mpdId)()}
                      </td>

                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <td key={productName} className="center">
                              {" "}
                              {this.state.credits[mpdId][productName]
                                ? this.state.credits[mpdId][productName]
                                    .quantity
                                : 0}
                            </td>
                          );
                        }
                      )}

                      <td className="center">
                        {this.getTotalCreditSaleQuanity.bind(this, mpdId)()}
                      </td>

                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <td key={productName} className="center">
                              {(
                                this.state.mpds[mpdId].products[productName]
                                  .totalQuantity -
                                (this.state.credits[mpdId][productName]
                                  ? this.state.credits[mpdId][productName]
                                      .quantity
                                  : 0)
                              ).toFixed(3)}
                            </td>
                          );
                        }
                      )}

                      {/*totla cash sale quantity*/}

                      <td className="center">
                        {this.getTotalCashSaleQuanity.bind(this, mpdId)()}
                      </td>
                    </tr>
                    <tr>
                      <td>In Rs.</td>
                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <td key={productName} className="center currency">
                              {currencyFormat(
                                this.state.mpds[mpdId].products[productName]
                                  .totalPrice
                              )}
                            </td>
                          );
                        }
                      )}

                      {/*total sale in rupees*/}
                      <td className="center currency">
                        {currencyFormat(
                          this.getTotalSaleinRupees.bind(this, mpdId)()
                        )}
                      </td>

                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <td key={productName} className="center currency">
                              <span>
                                {currencyFormat(
                                  this.state.credits[mpdId][productName]
                                    ? this.state.credits[mpdId][productName]
                                        .quantity *
                                        this.state.products[
                                          this.state.credits[mpdId][productName]
                                            .productId
                                        ].sellingPrice
                                    : 0
                                )}
                              </span>
                            </td>
                          );
                        }
                      )}

                      {/*total credit sale in rupees*/}
                      <td className="center currency">
                        {currencyFormat(
                          this.getTotalCreditSaleinRupees.bind(this, mpdId)()
                        )}
                      </td>

                      {Object.keys(this.state.mpds[mpdId].products).map(
                        (productName) => {
                          return (
                            <td key={productName} className="center currency">
                              {currencyFormat(
                                (
                                  this.state.mpds[mpdId].products[productName]
                                    .totalPrice -
                                  (this.state.credits[mpdId][productName]
                                    ? this.state.credits[mpdId][productName]
                                        .quantity *
                                      this.state.products[
                                        this.state.credits[mpdId][productName]
                                          .productId
                                      ].sellingPrice
                                    : 0)
                                ).toFixed(2)
                              )}
                            </td>
                          );
                        }
                      )}

                      {/*Total Cash Sale in rupees*/}

                      <td className="center currency">
                        {currencyFormat(
                          this.getTotalCashSaleinRupees.bind(this, mpdId)()
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="shiftClose">
                  <thead>
                    <tr>
                      <th>Swipe Machines</th>
                      <th>Swipe Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.mpds[mpdId].swipeMachines.map(
                      (swipeMachine, index) => {
                        return (
                          <tr key={swipeMachine.swipeId}>
                            <td>
                              {swipeMachine.swipeMachineName.toUpperCase()}
                            </td>
                            <td>
                              <input
                                type="text"
                                className="closeReading"
                                onKeyUp={this.updateSwipeAmount.bind(
                                  this,
                                  index,
                                  mpdId
                                )}
                                defaultValue={swipeMachine.amount}
                              />
                            </td>
                          </tr>
                        );
                      }
                    )}

                    <tr>
                      <td>Total</td>
                      <td className="center">
                        {this.calculateTotalSwpipe(mpdId)}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="shiftClose">
                  <thead>
                    <tr>
                      <th>Cash Collected</th>
                      <th>Cash to be collected</th>
                      <th>Collection from</th>
                      <th>Amount</th>
                      <th>Shortage Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="center currency">
                        {currencyFormat(
                          this.state.mpds[mpdId].cashCollection.cashCollection
                        )}
                      </td>
                      <td className="center currency">
                        {currencyFormat(
                          this.getTotalCashTobeCollected.bind(this, mpdId)()
                        )}
                      </td>
                      <td>
                        <AutoComplete
                          placeholder="select an employee"
                          dataSrc="api/v1/employee/auto"
                          dataTobind="employeeName"
                          keyToBind="employeeId"
                          tabIndex="2"
                          onSelect={this.onEmployeeSelect.bind(this, mpdId)}
                          reset={this.state.mpds[mpdId].resetEmployeeAuto}
                          rex={(searchBox) => {
                            this.searchBox = searchBox;
                            searchBox.value =
                              this.state.mpds[mpdId].lastCashCollection
                                .employeeName || "";
                          }}
                          inputStyle={{
                            color: "red",
                            textAlign: "center",
                            fontSize: "14px",
                            width: "150px",
                          }}
                          listStyle={{ width: "168px" }}
                        />
                      </td>
                      <td
                        className="center currency"
                        onClick={this.onAmountClicked.bind(this, mpdId)}
                      >
                        {currencyFormat(
                          this.state.mpds[mpdId].lastCashCollection.amount
                        )}
                      </td>

                      <td
                        className="center currency"
                        onClick={this.onShortageClick.bind(this, mpdId)}
                      >
                        {currencyFormat(
                          this.getTotalEmployeeShortage.bind(this, mpdId)()
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <EmployeeShortage
                  shortageAmount={this.state.mpds[mpdId].shortageAmount}
                  display={this.state.mpds[mpdId].showShortageForm}
                  onSave={this.onShortageSave.bind(this, mpdId)}
                  onCancle={this.onShortageCancle.bind(this, mpdId)}
                  reset={this.state.mpds[mpdId].resetEmployeeAuto}
                ></EmployeeShortage>
                <CurrencyEntry
                  visible={
                    this.state.mpds[mpdId].showCurrencyForm ? true : false
                  }
                  onSave={this.onCurrencySave.bind(this, mpdId)}
                  onCancel={this.onCurrencyCancel.bind(this, mpdId)}
                  reset={this.state.mpds[mpdId].resetEmployeeAuto}
                  prevCurrencies={
                    this.state.mpds[mpdId].lastCashCollection.currencyData
                  }
                ></CurrencyEntry>
              </div>
            </div>
          );
        })}

        {this.messageBox}
        {this.questionBox}
        {this.state.showCloseShiftBtn ? (
          <div>
            <div>
              <h2 className="mpd">All Tanks Dip</h2>
              <div>
                <div
                  style={{ display: "inline-block", margin: "10px 0 0 20px" }}
                >
                  <label style={{ cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        this.setState({ isAtg: e.target.checked });
                      }}
                      checked={this.state.isAtg}
                    />{" "}
                    volume by ATG
                  </label>
                </div>
                <table className="formTable" style={{ margin: 0 }}>
                  <tbody>
                    {this.state.tankList.map((tank, index) => {
                      return (
                        <tr key={tank.tankId}>
                          <td
                            style={{
                              background: "#a5a5a5",
                              color: "white",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              position: "relative",
                              whiteSpace: "nowrap",
                              border: "none",
                            }}
                          >
                            {tank.tankName}
                          </td>

                          <td style={{ color: "#a5a5a5" }}>
                            {tank.productName}
                          </td>
                          <td>
                            <input
                              type="number"
                              className="formControl inputBox"
                              style={{ width: "200px" }}
                              onChange={this.handleDip.bind(this, index, tank)}
                              defaultValue={tank.dip}
                              placeholder={
                                this.state.isAtg
                                  ? "Enter Fuel Height"
                                  : "Enter Dip"
                              }
                            />
                          </td>
                          {this.state.isAtg ? (
                            <td>
                              <input
                                type="number"
                                className="formControl inputBox"
                                placeholder="Enter Volume in Ltrs"
                                onChange={this.handleVolume.bind(
                                  this,
                                  index,
                                  tank
                                )}
                                defaultValue={tank.volumeInLtrs}
                                style={{ width: "200px" }}
                              />
                            </td>
                          ) : (
                            <td
                              style={{
                                color: "#927878",
                                width: "100px",
                                textAlign: "right",
                              }}
                            >
                              {tank.volumeInLtrs}
                            </td>
                          )}
                          {tank.volumeInLtrs ? (
                            <td style={{ color: "#927878" }}>Ltrs</td>
                          ) : (
                            <td></td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div>
                <p style={{ color: "#927878" }}>Shift Comment</p>
                <textarea
                  rows="3"
                  cols="76"
                  type="text"
                  className="formControl "
                  placeholder="Enter Shift Comment"
                  onChange={this.handleComment}
                  defaultValue={this.state.comment}
                />
                <button
                  className="btn btnOk btnRight"
                  style={{ marginTop: "50px" }}
                  onClick={this.closeShift.bind(this)}
                >
                  Close Shift
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
  handleVolume(index, tank, e) {
    var inpValue = parseFloat(e.target.value);
    if (this.state.isAtg) {
      let tankList = update(this.state.tankList, {
        [index]: { volumeInLtrs: { $set: inpValue } },
      });
      tankList.isAtg = this.state.isAtg;
      this.setState({ tankList });
    }
  }
  handleComment = (e) => {
    var comment = e.target.value;
    this.setState({ comment: comment });
  };
  validateTankDip() {
    var allTankDip = this.state.tankList.every((tank) => {
      return tank.volumeInLtrs > 0;
    });
    return allTankDip;
  }
  handleDip(index, tank, e) {
    var inpValue = parseFloat(e.target.value);
    if (!this.state.isAtg) {
      if (inpValue > 0) {
        rq.getJsonData(`/api/v1/dip-volume/${tank.tankId}/${inpValue}`)
          .then((data) => {
            if (data.length > 0) {
              let tankList = update(this.state.tankList, {
                [index]: {
                  dip: { $set: inpValue },
                  volumeInLtrs: { $set: data[0].volumeInLtrs },
                },
              });
              tankList.isAtg = this.state.isAtg;
              this.setState({ tankList });
              //  console.log(tankList);
            } else {
              let tankList = update(this.state.tankList, {
                [index]: { dip: { $set: inpValue }, volumeInLtrs: { $set: 0 } },
              });
              tankList.isAtg = this.state.isAtg;
              this.setState({ tankList });
            }
          })
          .catch(() => {});
      } else {
        let tankList = update(this.state.tankList, {
          [index]: { dip: { $set: 0 }, volumeInLtrs: { $set: 0 } },
        });
        tankList.isAtg = this.state.isAtg;
        this.setState({ tankList });
      }
    } else {
      let tankList = update(this.state.tankList, {
        [index]: { dip: { $set: inpValue } },
      });
      tankList.isAtg = this.state.isAtg;
      this.setState({ tankList });
    }
    console.log(this.state.tankList);
  }
  getTotalSaleQuanity(mpdId) {
    var totalQuanity = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalQuanity +=
        this.state.mpds[mpdId].products[productName].totalQuantity;
    });
    return totalQuanity.toFixed(3);
  }

  getTotalCreditSaleQuanity(mpdId) {
    var totalQuanity = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalQuanity += this.state.credits[mpdId][productName]
        ? this.state.credits[mpdId][productName].quantity
        : 0;
    });
    return totalQuanity.toFixed(3);
  }

  getTotalCashSaleQuanity(mpdId) {
    var totalQuanity = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalQuanity +=
        this.state.mpds[mpdId].products[productName].totalQuantity -
        (this.state.credits[mpdId][productName]
          ? this.state.credits[mpdId][productName].quantity
          : 0);
    });
    return totalQuanity.toFixed(3);
  }

  getTotalSaleinRupees(mpdId) {
    var totalQuanity = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalQuanity += this.state.mpds[mpdId].products[productName].totalPrice;
    });
    return totalQuanity.toFixed(2);
  }

  getTotalCreditSaleinRupees(mpdId) {
    var totalQuanity = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalQuanity += this.state.credits[mpdId][productName]
        ? this.state.credits[mpdId][productName].quantity *
          this.state.products[this.state.credits[mpdId][productName].productId]
            .sellingPrice
        : 0;
    });
    return totalQuanity.toFixed(2);
  }

  getTotalCashSaleinRupees(mpdId) {
    var totalQuanity = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalQuanity +=
        this.state.mpds[mpdId].products[productName].totalPrice -
        (this.state.credits[mpdId][productName]
          ? this.state.credits[mpdId][productName].quantity *
            this.state.products[
              this.state.credits[mpdId][productName].productId
            ].sellingPrice
          : 0);
    });
    return totalQuanity.toFixed(2);
  }

  getTotalCashTobeCollected(mpdId) {
    var totalCashSale = 0;
    Object.keys(this.state.mpds[mpdId].products).forEach((productName) => {
      totalCashSale +=
        this.state.mpds[mpdId].products[productName].totalPrice -
        (this.state.credits[mpdId][productName]
          ? this.state.credits[mpdId][productName].quantity *
            this.state.products[
              this.state.credits[mpdId][productName].productId
            ].sellingPrice
          : 0);
    });
    return (
      totalCashSale -
      (this.state.mpds[mpdId].cashCollection.cashCollection +
        this.calculateTotalSwpipe(mpdId))
    ).toFixed(2);
  }

  makeAjax(url, successCb, errCb) {
    rq.getJsonData(url)
      .then((data) => {
        successCb(data);
      })
      .catch(() => {
        errCb();
      });
  }

  toDecimal3(number) {
    number = number.toString().split(".");
    if (number[1]) {
      number[1] = number[1].substring(0, 3);
    }

    return parseFloat(number[0] + "." + number[1]);
  }
  getTotalEmployeeShortage(mpdId) {
    // console.log("..........",this.state.mpds[mpdId].employeeShortageList);
    var totalShortage = 0;
    if (this.state.mpds[mpdId].employeeShortageList) {
      this.state.mpds[mpdId].employeeShortageList.forEach(
        (employeeShortage) => {
          totalShortage += employeeShortage.amount;
        }
      );
    }
    return totalShortage;
  }
}



// WEBPACK FOOTER //
// ./src/jsx/components/pages/close-shift.jsx